import { startCase } from 'lodash';
import { lazy } from 'react';
import styled from 'styled-components';
import type { AppRouter, ModuleRouter } from '@tools/ui/types';
import {
  allowedCollections,
  collectionDisplayEmoji
} from '../pages/watson/utils/allowedCollections';

const prefixPath = '/watson';

const StyledAvatar = styled.div`
  font-size: 19px;
`;

const Drawer = lazy(
  () =>
    import(
      /* webpackChunkName: "WatsonRoutes" */ '../pages/watson/pages/drawer'
    )
);

const View = lazy(
  () =>
    import(/* webpackChunkName: "WatsonRoutes" */ '../pages/watson/pages/view')
);

const baseRoutes = allowedCollections.map(
  (collection: string): ModuleRouter => ({
    name: `${startCase(collection)}`,
    path: `${prefixPath}/${collection}`,
    icon: () => (
      <StyledAvatar>{collectionDisplayEmoji[collection]}</StyledAvatar>
    ),
    exact: true,
    component: () => (
      <>
        <Drawer />
        <View collectionName={collection} />
      </>
    ),
    pages: []
  })
);

export const watsonRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    ...baseRoutes
  ]
};
